module.exports = __webpack_public_path__ + "img/icon-conservation.5065659e.png";